export const proposalQueryKeys = {
  all: ["proposals"] as const,
  lists: () => [...proposalQueryKeys.all, "list"] as const,
  list: (
    organizationId?: string,
    filters?: Record<string, unknown> | object,
    sort?: { field: string; direction: "asc" | "desc" },
    page?: number,
    limit?: number,
  ) =>
    [
      ...proposalQueryKeys.lists(),
      organizationId,
      filters ? JSON.stringify(filters) : undefined,
      sort,
      page,
      limit,
    ] as const,
  details: () => [...proposalQueryKeys.all, "detail"] as const,
  detail: (organizationId: string | undefined, proposalId: string) =>
    [...proposalQueryKeys.details(), organizationId, proposalId] as const,
  invoiceScheduleDraft: (
    organizationId: string | undefined,
    proposalId: string,
  ) =>
    [
      ...proposalQueryKeys.all,
      "invoice-schedule-draft",
      organizationId,
      proposalId,
    ] as const,
  metrics: (
    organizationId?: string,
    filters?: Record<string, unknown> | object,
  ) =>
    [
      ...proposalQueryKeys.all,
      "metrics",
      organizationId,
      filters ? JSON.stringify(filters) : undefined,
    ] as const,
} as const;

import type { QueryClient } from "@tanstack/react-query";

export function invalidateAllProposalQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: proposalQueryKeys.all });
}
